/* eslint-disable */
export const maxLifetime = 14

export default [
[ 0, 1000 ],
[ 1, 277 ],
[ 2, 146 ],
[ 3, 38 ],
[ 4, 15 ],
[ 5, 15 ],
[ 6, 15 ],
[ 7, 15 ],
[ 8, 7 ],
[ 9, 0 ]
]
